import { z } from 'zod/v4';

export const InputSchema = z.object({ accountId: z.number() });

export type GetTransactionsTotalDepositsSchemaType = z.infer<typeof InputSchema>;

export const BankTransferPaymentMethodSchema = z
    .object({
        id: z.string(),
    })
    .strict();

export const FullPaymentMethodSchema = z.object({
    id: z.string(),
    name: z.string(),
    type: z.string(),
    number: z.string(),
    expires: z.union([z.iso.date(), z.null(), z.undefined()]).optional(),
    subtype: z.string(),
    provider: z.string(),
    lastUsedAt: z.iso.datetime().nullable().optional(),
    lastDepositAt: z.string().datetime().nullable().optional(),
    bankAccountName: z.string().nullable().optional(),
    providerReference: z.string().nullable().optional(),
});

export const TempInvalidPaysafeWithoutCardSchema = FullPaymentMethodSchema.extend({
    name: z.null(),
    number: z.null(),
});

export const FullPaymentMethodsArraySchema = z.array(FullPaymentMethodSchema);
export const BankTransferPaymentMethodsArraySchema = z.array(BankTransferPaymentMethodSchema);
export const FullPaymentMethodsSchema = FullPaymentMethodSchema;
export const BankTransferPaymentsMethodsSchema = z.array(BankTransferPaymentMethodSchema);

export const PaymentMethodSchema = z.union([
    FullPaymentMethodSchema,
    BankTransferPaymentMethodSchema,
    TempInvalidPaysafeWithoutCardSchema,
]);

const AggregationsSchema = z.object({
    totalCount: z.number().nonnegative(),
    totalAmount: z.string(),
    firstTransaction: z.iso.datetime(),
    latestTransaction: z.iso.datetime(),
});

export const PaymentMethodObjectSchema = z.object({
    paymentMethods: z.array(PaymentMethodSchema),
    aggregations: AggregationsSchema,
});

export const PaymentSingleObjectSchema = z.object({
    paymentMethod: PaymentMethodSchema,
    aggregations: AggregationsSchema,
});

export const SuccessResponseSchema = z.object({
    results: z.array(PaymentMethodObjectSchema),
});

export type SuccessResponseType = z.infer<typeof SuccessResponseSchema>;
export type PaymentMethodObjectSchemaType = z.infer<typeof PaymentMethodObjectSchema>;
export type PaymentSingleObjectSchemaType = z.infer<typeof PaymentSingleObjectSchema>;

export type FullPaymentMethodSchemaType = z.infer<typeof FullPaymentMethodsSchema>;
export type BankTransferPaymentMethodSchemaType = z.infer<typeof BankTransferPaymentMethodSchema>;
export type PaymentUnionSchemaType = z.infer<typeof PaymentMethodSchema>;

export type ResponseType =
    | { responseStatus: 'success'; data: SuccessResponseType }
    | {
          responseStatus: 'error';
          status: number;
          unparsedData?: unknown;
      };
